import React from 'react'

import { Portlet, Form, Row, Col } from '_zari/core'

import * as Formatos from './formatos'

const TIPOSREPORTE = {
  LIBROMAYOR6_1: '1',
  RESUMENDELMAYOR: '2',
  GASTOSPORCUENTA: '3'
}

const ReporteDiario = () => {
  const [tipoReporte, setTipoReporte] = React.useState(TIPOSREPORTE.LIBROMAYOR6_1)

  return (
    <Portlet>
      <Portlet.Header title='Libro Mayor' />
      <Portlet.Body>
        <Row>
          <Col md={3}>
            <Form.Radio
              id='radio-libroMayor6.1'
              name='tipoReporte'
              label='LIBRO MAYOR 6.1'
              value={TIPOSREPORTE.LIBROMAYOR6_1}
              checked={tipoReporte === TIPOSREPORTE.LIBROMAYOR6_1}
              onChange={() => setTipoReporte(TIPOSREPORTE.LIBROMAYOR6_1)}
            />
            <Form.Radio
              id='radio-resumenDelMayor'
              name='tipoReporte'
              label='RESUMEN DEL MAYOR'
              value={TIPOSREPORTE.RESUMENDELMAYOR}
              checked={tipoReporte === TIPOSREPORTE.RESUMENDELMAYOR}
              onChange={() => setTipoReporte(TIPOSREPORTE.RESUMENDELMAYOR)}
            />
            <Form.Radio
              id='radio-gastosPorCuenta'
              name='tipoReporte'
              label='GASTOS POR CUENTA'
              value={TIPOSREPORTE.GASTOSPORCUENTA}
              checked={tipoReporte === TIPOSREPORTE.GASTOSPORCUENTA}
              onChange={() => setTipoReporte(TIPOSREPORTE.GASTOSPORCUENTA)}
            />
          </Col>
          <Col md={9} style={{ borderLeft: '1px solid black' }}>
            {tipoReporte === TIPOSREPORTE.LIBROMAYOR6_1 && <Formatos.Formato6p1 />}
            {tipoReporte === TIPOSREPORTE.RESUMENDELMAYOR && <Formatos.FormatoResumenDelMayor />}
            {tipoReporte === TIPOSREPORTE.GASTOSPORCUENTA && <Formatos.FormatoGastosPorCuenta />}
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReporteDiario)
